import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  const { state } = useLocation();
  if (!state?.reference) return <Navigate to="/booking" replace />;
  return (
    <div className="pt-32 pb-24 min-h-screen bg-brand-canvas" data-testid="booking-thank-you">
      <div className="max-w-lg mx-auto px-4 text-center">
        <div className="bg-white rounded-3xl border border-[#D6E4DC] p-10 shadow-xl">
          <CheckCircle2 className="w-16 h-16 text-brand-lime mx-auto mb-5" />
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-brand-lime mb-2">Thank You</p>
          <h1 className="font-display text-3xl font-extrabold text-brand-emerald">Your booking is successful.</h1>
          <p className="mt-3 text-brand-muted">Booking reference</p>
          <p className="font-display text-2xl font-extrabold text-brand-gold tracking-wider mt-1" data-testid="booking-reference">{state.reference}</p>
          <p className="mt-4 text-sm text-brand-muted leading-relaxed">
            We have received your booking and sent a confirmation to <strong>{state.email}</strong>. Our team will contact <strong>{state.phone}</strong> to confirm the final arrangements.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="px-6 py-3 rounded-full bg-brand-emerald text-white font-bold hover:bg-brand-lime transition-colors">Back Home</Link>
            <Link to="/booking" className="px-6 py-3 rounded-full border-2 border-brand-emerald/20 text-brand-emerald font-bold hover:border-brand-lime transition-colors">Book Another</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
